import { asignarEncuestaFormModel } from './asignarEncuestaFormModel';

const {
  formField: { deviceManagementId, surveyId },
} = asignarEncuestaFormModel;

export const formInitialValues = {
  [deviceManagementId.name]: '',
  [surveyId.name]: [],
};
